function getLocks(): Set<string> {
  const raw = document.body.dataset.scrollLocks ?? "";
  return new Set(raw.split(",").map(s => s.trim()).filter(Boolean));
}

function setLocks(locks: Set<string>) {
  const next = Array.from(locks).join(",");
  if (next) document.body.dataset.scrollLocks = next;
  else delete document.body.dataset.scrollLocks;

  // If any lock exists, prevent background scroll.
  document.body.style.overflow = locks.size ? "hidden" : "";
}

export function lockBodyScroll(lockId: string) {
  if (typeof document === "undefined") return;
  const locks = getLocks();
  locks.add(lockId);
  setLocks(locks);
}

export function unlockBodyScroll(lockId: string) {
  if (typeof document === "undefined") return;
  const locks = getLocks();
  locks.delete(lockId);
  setLocks(locks);
}

